import ResetPasswordForm from '@/modules/reset-password'
import useMutationUpdateOperator from '../../api/hooks/useMutationUpdateOperator'

export const AdminResetPasswordOperatorForm = ({
	operatorId,
}: {
	operatorId: string
}) => {
	const { mutateAsync: mutateUpdateOperator } =
		useMutationUpdateOperator(operatorId)

	return <ResetPasswordForm handleSubmit={mutateUpdateOperator} />
}
